var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;var self = locals || {};const cookies = self.htmlWebpackPlugin.options.data.content.cookies
pug_html = pug_html + "\u003Cdiv class=\"banner-cookies\" id=\"cookiesbanner\" style=\"display: none;\"\u003E\u003Cdiv class=\"wrapper\"\u003E\u003Cdiv class=\"banner-cookies_l\"\u003E\u003Cp\u003ECe site utilise des cookies à des fins de fonctionnement, d’analyses statistiques et de personnalisation de votre expérience. En continuant à utiliser ce site vous consentez à leur utilisation.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"banner-cookies_r\"\u003E\u003Ca class=\"btn-cookies\" id=\"cookies-ok\"\u003EJ’ai compris\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/pages/components/cookies_banner.pug
// module id = 797
// module chunks = 0